// extracted by mini-css-extract-plugin
export default {"container":"SearchBar_container__xwaer","inputContainer":"SearchBar_inputContainer__6OuJl","btn":"SearchBar_btn__PKGSc"};